package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.common.usecases.RemoveColonSplitterUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveNikudAndMakafUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveTeamimUseCase
import com.eladfinish.bible.contest.constants.StringConstants.Regex.WORD_CHAR
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.utils.getRegexOfSingleOtPasukAleph
import com.eladfinish.bible.contest.utils.removeAliyotMarkersAfterNewline
import com.eladfinish.bible.contest.utils.removeOtPasukAfterNunMenuzeret
import com.eladfinish.bible.contest.utils.replaceOtiotPasuk

class GetTikunKorimFormatUseCase(
    private val removeTeamimUseCase: RemoveTeamimUseCase,
    private val removeNikudAndMakafUseCase: RemoveNikudAndMakafUseCase,
    private val removeColonSplitterUseCase: RemoveColonSplitterUseCase,
) {

    operator fun invoke(originalText: String): String {
        return removeTeamimUseCase(pasuk = originalText, isTikunKorim = true)
            .let(removeNikudAndMakafUseCase::invoke)
            .let(::removeVerseLetter)
            .let(removeColonSplitterUseCase::invoke)
            .let(::removeAliyot1)
            .let(::removeAliyot2)
            .let(::removePerekString)
//            .let(::removeMultipleSpaces)
            .trim()
    }

    private fun removeVerseLetter(content: String): String {
        return content
            .replaceRegex(regex = getRegexOfSingleOtPasukAleph(), replacement = "").trim()
            .replaceOtiotPasuk(literalReplacement = "").trim()
            .removeOtPasukAfterNunMenuzeret().trim()
    }

    private fun removeAliyot1(content: String): String =
        content.removeAliyotMarkersAfterNewline()

    private fun removeAliyot2(content: String): String =
        content.replaceRegex(
            regex = "\\[.*?\\]\\s+",
            replacement = ""
        )

    private fun removePerekString(content: String): String =
        content.replaceRegex(
            // WORD_CHAR lookarounds rather than \b: JS RegExp's \b is ASCII-only (see WORD_CHAR)
            regex = "\\s?(?<!$WORD_CHAR)פרק(?!$WORD_CHAR)\\s?",
            replacement = ""
        )

//    private fun removeMultipleSpaces(content: String): String =
//        content.replaceRegex(
//            regex = "\\s+",
//            replacement = " "
//        )

}
